import ProductGrid from './ProductGrid';
import { projects } from '../assets/projects';

const FeaturedProjects = () => {
    const type = "Featured";
    const featured = projects.filter(product => product.type.toLowerCase() === type.toLowerCase());


    return (
        <>
        <div className="location-page">
              <ProductGrid products={featured} />
         </div>
        </>
    )
};

export default FeaturedProjects;